export default "__VITE_ASSET__CDkyNBr4__"